'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _createForOfIteratorHelper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js").default;
var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var _assertThisInitialized = require("/vercel/path0/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;
var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/createSuper.js").default;
var _wrapNativeSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/wrapNativeSuper.js").default;
var indentString = require('indent-string');
var cleanStack = require('clean-stack');
var cleanInternalStack = function cleanInternalStack(stack) {
  return stack.replace(/\s+at .*aggregate-error\/index.js:\d+:\d+\)?/g, '');
};
var AggregateError = /*#__PURE__*/function (_Error, _Symbol$iterator) {
  _inherits(AggregateError, _Error);
  var _super = _createSuper(AggregateError);
  function AggregateError(errors) {
    var _this;
    _classCallCheck(this, AggregateError);
    if (!Array.isArray(errors)) {
      throw new TypeError("Expected input to be an Array, got ".concat(typeof errors));
    }
    errors = _toConsumableArray(errors).map(function (error) {
      if (error instanceof Error) {
        return error;
      }
      if (error !== null && typeof error === 'object') {
        // Handle plain error objects with message property and/or possibly other metadata
        return Object.assign(new Error(error.message), error);
      }
      return new Error(error);
    });
    var message = errors.map(function (error) {
      // The `stack` property is not standardized, so we can't assume it exists
      return typeof error.stack === 'string' ? cleanInternalStack(cleanStack(error.stack)) : String(error);
    }).join('\n');
    message = '\n' + indentString(message, 4);
    _this = _super.call(this, message);
    _this.name = 'AggregateError';
    Object.defineProperty(_assertThisInitialized(_this), '_errors', {
      value: errors
    });
    return _this;
  }
  _createClass(AggregateError, [{
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      var _iterator, _step, error;
      return _regeneratorRuntime().wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _iterator = _createForOfIteratorHelper(this._errors);
            _context.prev = 1;
            _iterator.s();
          case 3:
            if ((_step = _iterator.n()).done) {
              _context.next = 9;
              break;
            }
            error = _step.value;
            _context.next = 7;
            return error;
          case 7:
            _context.next = 3;
            break;
          case 9:
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            _iterator.e(_context.t0);
          case 14:
            _context.prev = 14;
            _iterator.f();
            return _context.finish(14);
          case 17:
          case "end":
            return _context.stop();
        }
      }, value, this, [[1, 11, 14, 17]]);
    })
  }]);
  return AggregateError;
}( /*#__PURE__*/_wrapNativeSuper(Error), Symbol.iterator);
module.exports = AggregateError;